import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  exploreHeading: {
    id: 'discover.explore.heading',
    defaultMessage: 'Explore Courses',
    description: 'Heading for the explore courses page',
  },
  searchPlaceholder: {
    id: 'discover.explore.searchPlaceholder',
    defaultMessage: 'Search courses..',
    description: 'Placeholder for the discover/explore courses search input',
  },
  sortLabel: {
    id: 'discover.explore.sortLabel',
    defaultMessage: 'Sort by',
    description: 'Prefix label for the sort dropdown on the explore courses page',
  },
  sortNewest: {
    id: 'discover.explore.sort.newest',
    defaultMessage: 'Newest',
    description: 'Sort option: newest courses first',
  },
  sortNameAsc: {
    id: 'discover.explore.sort.nameAsc',
    defaultMessage: 'Name (A–Z)',
    description: 'Sort option: title ascending',
  },
  sortNameDesc: {
    id: 'discover.explore.sort.nameDesc',
    defaultMessage: 'Name (Z–A)',
    description: 'Sort option: title descending',
  },
  sortPriceAsc: {
    id: 'discover.explore.sort.priceAsc',
    defaultMessage: 'Price: Low to High',
    description: 'Sort option: price ascending',
  },
  sortPriceDesc: {
    id: 'discover.explore.sort.priceDesc',
    defaultMessage: 'Price: High to Low',
    description: 'Sort option: price descending',
  },
  sortRating: {
    id: 'discover.explore.sort.rating',
    defaultMessage: 'Top Rated',
    description: 'Sort option: highest rating first',
  },
  newBadge: {
    id: 'discover.card.newBadge',
    defaultMessage: 'New',
    description: 'Badge indicating a recently added course or program',
  },
  subscriptionLabel: {
    id: 'discover.card.subscriptionLabel',
    defaultMessage: 'Subscription',
    description: 'Shown in place of a price when the item can only be obtained by subscribing',
  },
  inviteOnlyLabel: {
    id: 'discover.card.inviteOnlyLabel',
    defaultMessage: 'Invite only',
    description: 'Shown in place of a price when only staff can enroll learners in the item',
  },
  addToWishlist: {
    id: 'discover.card.addToWishlist',
    defaultMessage: 'Add to wishlist',
    description: 'Accessible label for the icon button that adds an item to the wishlist',
  },
  removeFromWishlist: {
    id: 'discover.card.removeFromWishlist',
    defaultMessage: 'Remove from wishlist',
    description: 'Accessible label for the icon button that removes an item from the wishlist',
  },
  noReviews: {
    id: 'discover.card.noReviews',
    defaultMessage: 'No reviews',
    description: 'Shown on a discover card when a course or program has no reviews yet',
  },
  extraSkillsCount: {
    id: 'discover.card.extraSkillsCount',
    defaultMessage: '+{count} Skills',
    description: 'Badge indicating additional skills beyond what is displayed on a discover card',
  },
  learnMore: {
    id: 'discover.banner.learnMore',
    defaultMessage: 'Learn more',
    description: 'Link text on the featured course banner that opens the course detail page',
  },
  ratingReviews: {
    id: 'discover.card.ratingReviews',
    defaultMessage: '{rating} ({count, plural, one {# review} other {# reviews}})',
    description: 'Average rating followed by the number of reviews, e.g. "3 (1 review)"',
  },
  durationHoursMinutes: {
    id: 'discover.card.durationHoursMinutes',
    defaultMessage: '{hours}h {minutes}m',
    description: 'Course duration shown as hours and minutes, e.g. "62h 4m"',
  },
  durationHours: {
    id: 'discover.card.durationHours',
    defaultMessage: '{hours}h',
    description: 'Course duration shown as whole hours, e.g. "62h"',
  },
  durationMinutes: {
    id: 'discover.card.durationMinutes',
    defaultMessage: '{minutes}m',
    description: 'Course duration shown as minutes only, e.g. "45m"',
  },
  loadingCourses: {
    id: 'discover.explore.loading',
    defaultMessage: 'Loading courses',
    description: 'Screen reader text shown while the discover/explore courses are loading',
  },
  coursesLoadError: {
    id: 'discover.explore.loadError',
    defaultMessage: 'Unable to load courses. Please try again later.',
    description: 'Error message shown when discover/explore courses fail to load',
  },
});

export default messages;
